import React, { useEffect, useState, useRef } from "react";
import { Modal, TabsNavigation, Tab, Icon, Toggle } from "pepsico-ds";
import Settings from '../../assets/Settings.svg'
import Info from '../../assets/Info.svg'
import Vector from '../../assets/Vector.png'
import { UpdateSubscribeAction } from "../../redux/action/BroadcastAppBellAction";
import { useToast } from "../Toast/ToastContext";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { FetchLandingPageAction } from "../../redux/action/LandingPageAction";
import { useAuth } from "../../utils/auth/useAuth";
import { getUserClaims } from "../../utils/auth/unified-auth";

const SettingsModal = ({ onClose }) => {
  const dispatch = useDispatch()
  const { showToast } = useToast();
  const userData = useSelector((state) => state.getLandingPageReducer);
//   const [emailEnabled, setEmailEnabled] = useState(userData?.isSubscribedToNotifications);

  const [emailEnabled, setEmailEnabled] = useState(() => {
  const storedValue = localStorage.getItem("user-email-subscribed");

  if (storedValue !== null && storedValue !== "") {
    return JSON.parse(storedValue); // because localStorage stores strings
  }

  return userData?.isSubscribedToNotifications ?? false;
});

  const { authState } = useAuth();
  const [userInfo, setUserInfo] = useState({});
  const [isDataLoading, setIsDataLoading] = useState(true);
  const [isUserDataFetched, setIsUserDataFetched] = useState(false)
  /* istanbul ignore next */
  useEffect(() => {
        async function fetchUserInfo() {
            const user = await getUserClaims();
            if (user) {
                setUserInfo(user);
                // dispatch(FetchLandingPageAction(user));
                setIsUserDataFetched(true)
            }
        }
        setIsDataLoading(true)
        fetchUserInfo();
    }, []);
  /* istanbul ignore next */
//   useEffect(()=>{
    
//     if (userData && typeof emailEnabled === "boolean" && emailEnabled !== userData?.isSubscribedToNotifications) {
//         const isEnabled = emailEnabled;

//             onClose();
        

//         showToast(
//             isEnabled ? "success" : "info",
//             isEnabled
//             ? "Email subscriptions have been enabled."
//             : "Email subscriptions have been disabled.",
//             {
//             icon: (
//                 <img
//                 src={isEnabled ? Vector : Info}
//                 alt="image"
//                 style={{ width: "20px", height: "20px" }}
//                 />
//             ),
//             }
//         );
//         localStorage.setItem("user-email-subscribed", emailEnabled);

  

//         // onTrigger()
//     }

    
//   },[emailEnabled])

    const isFirstRender = useRef(true);
/* istanbul ignore next */
useEffect(() => {
  if (isFirstRender.current) {
    isFirstRender.current = false;
    return; 
  }

  if (
    userData &&
    typeof emailEnabled === "boolean" 
    // && emailEnabled !== userData?.isSubscribedToNotifications
  ) {
    const isEnabled = emailEnabled;

    onClose();

    showToast(
      isEnabled ? "success" : "info",
      isEnabled
        ? "Email subscriptions have been enabled."
        : "Email subscriptions have been disabled.",
      {
        icon: (
          <img
            src={isEnabled ? Vector : Info}
            alt="image"
            style={{ width: "20px", height: "20px" }}
          />
        ),
      }
    );
    localStorage.setItem(
      "user-email-subscribed",
      JSON.stringify(emailEnabled)
    );
  }
}, [emailEnabled]);

  return (
    <>
        <Modal                   
                      className="profile-settings-modal"
                      closeOnOutsideClick={true}
                    //   hideCloseButton
                      onCloseModal={function oFe(){onClose()}}
                    //   primaryButtonProps={{
                    //   onClick: onClose,
                    //   size: 'medium',
                    //   text: 'Go Back',
                    //   variant: 'primary'
                    //   }}
                      showModal={true}
                      showLink={false}
                      showPrimaryButton={false}
                      showSecondaryButton={false}
                      showTertiaryButton={false}
                      showAuxiliaryButton={false}
                      type="M"
                      title={
                        <>
                                <div className="settings-header">
                                <div className="settings-title">
                                <span className="gear">
                                    <img src={Settings} /> 
                                    <span className="settings-name">Settings</span>
                                </span>
                            </div>
                            </div>
                        </>
                      }
                  >
                    <div style={{height: '100%'}}>
                        {/* <div style={{height: '100%'}}> */}
                            
                            {/* Header */}
                           

                            <p className="settings-subtitle">
                            Customize how your account works, update your preferences,
                            and manage security settings.
                            </p>

                            <div className="settings-body">
                            
                                {/* Sidebar */}
                                {/* <div className="settings-sidebar"> */}
                                <div className="settings-subbody">
                                    <div >
                                        <TabsNavigation
                                        className=""
                                        selectedIndex={0}
                                        style={{}}
                                        orientation="vertical"
                                        >
                                        
                                        <Tab
                                            label="Notifications"
                                            orientation="vertical"
                                        />
                                        </TabsNavigation>

                                      
                                    </div>
                                    <div className="settings-verticle-line"></div>

                                    {/* Main Content */}
                                    <div className="settings-content">
                                        <div className="settings-subcontent">
                                            <span className="settings-notifications-title"> <Icon alt="" icon="notifications"  /> Notifications</span>
                                            <p className="settings-notifications-subtitle">
                                            Configure your notification preferences to control which
                                            updates you receive
                                            </p>

                                            <div className="settings-email-text">
                                            {/* <span className=""> */}
                                                <Icon alt="" icon="email" />
                                                <span className="settings-email-subtext">
                                                    Enable email subscription to Procurement Hub updates
                                                </span>
                                                
                                                <Toggle 
                                                    onUpdate={() => {
                                                        const newValue = !emailEnabled;
                                                        let request={
                                                            "userId": userData?.emailId,
                                                            "subscribed": newValue
                                                        }
                                                        dispatch(UpdateSubscribeAction(request))
                                                        // dispatch(FetchLandingPageAction())
                                                        setTimeout(() => {
                                                            setEmailEnabled(newValue)
                                                        }, [500]);
                                                       
                                                        
                                                    }}
                                                    // size="small"
                                                    showCheckedIcon={false}
                                                    // checked={userData?.isSubscribedToNotifications}
                                                    checked={emailEnabled}
                                                    style={{marginLeft: 'auto'}}
                                                    // value=""
                                                    // variant="horizontal"
                                                />
                                            {/* </span> */}

                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        {/* </div> */}
                    </div>
                  </Modal>
    </>
    
  );
};

export default SettingsModal;
